import React from 'react';
import Alert from 'modules/shared/components/alert';
import classNames from 'classnames';
import Price from 'atomic/price';

import './alert-discount-price-info.scss';

type paddings = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

interface AlertDiscountPriceInfoProps {
    paddingBottom?: paddings;
    paddingTop?: paddings;
    minPrice30Days?: number;
}

const AlertDiscountPriceInfo: React.FC<AlertDiscountPriceInfoProps> = ({ paddingBottom = 0, paddingTop = 0, minPrice30Days = 0 }) => (
    <div
        className={classNames({
            'alert-discount-price-info': true,
            [`alert-discount-price-info--pb-${paddingBottom}`]: paddingBottom > 0,
            [`alert-discount-price-info--pt-${paddingTop}`]: paddingTop > 0
        })}
    >
        <Alert color="info">
            Najniższa cena z 30&nbsp;dni przed obniżką <Price price={minPrice30Days} color="secondary" fontSize={10} />
        </Alert>
    </div>
);

export default AlertDiscountPriceInfo;
